import React, { useState } from "react";
import { Typography, Button } from "@mui/material";
import "./wellnessreportpopup.scss";

const WellnessReportPopup = ({ isOpen, onClose, onAccept }) => {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleAccept = () => {
    onAccept(dontShowAgain);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="wellness-popup-overlay">
      <div className="wellness-popup-content">
        <div className="wellness-popup-header">
          <Typography className="wellness-popup-title">
            <strong>Disclaimer</strong>
          </Typography>
        </div>

        <div className="wellness-popup-body">
          <Typography className="wellness-disclaimer-heading">
            You are leaving the Mobility Metrics Tracker.
          </Typography>
          <br />
          <Typography className="wellness-disclaimer-text">
            The following are wellness features only—not medical advice.
            Recommendations may be customized. Consult a clinician before
            acting.
          </Typography>
          <br />
          <Typography className="wellness-disclaimer-text">
            SeniorLife Technologies Inc. is not responsible for use.
          </Typography>

          <div className="wellness-checkbox-container">
            <label className="wellness-checkbox-label">
              <input
                type="checkbox"
                checked={dontShowAgain}
                onChange={(e) => setDontShowAgain(e.target.checked)}
                className="wellness-checkbox"
              />
              <span className="wellness-checkbox-text">
                Don&apos;t show it again
              </span>
            </label>
          </div>
        </div>

        <div className="wellness-popup-footer">
          <Button
            variant="contained"
            className="wellness-accept-button"
            onClick={handleAccept}
          >
            Agree and Proceed
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WellnessReportPopup;
